import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { UploadFile } from "antd";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  errors: Array<{ fileName: string; errors: string[] }>;
  isFileModalOpen: boolean;
  isFileLoading: boolean;
  isImportActivate: boolean;
  file: UploadFile;
  filename: string;
  typeId: number;
} = {
  loading: false,
  loadingData: false,

  isImportActivate: false,
  errors: [],

  isFileModalOpen: false,
  isFileLoading: false,
  file: undefined!,
  filename: "",
  typeId: 0,
};

const importRoutesSlice = createSlice({
  name: "importRoutes",
  initialState,
  reducers: {
    setIsImportActivate(state, action: PayloadAction<boolean>) {
      state.isImportActivate = action.payload;
    },
    uploadDocument(state, action: PayloadAction<{ file: UploadFile; filename: string; typeId: number }>) {
      const { file, filename, typeId } = action.payload;
      state.isFileLoading = true;
      state.file = file;
      state.filename = filename;
      state.typeId = typeId;
    },
    uploadDocumentError(state) {
      state.isFileLoading = false;
    },
    resetErrorsState(state) {
      state.errors = [];
    },
    setErrors(state, action: PayloadAction<{ fileName: string; errors: string[] }>) {
      const errors = state.errors.filter((error) => error.fileName !== action.payload.fileName);
      errors.push(action.payload);
      state.errors = errors;
    },
    deleteSuccessFileFromErrors(state, action: PayloadAction<string>) {
      state.errors = state.errors.filter((error) => error.fileName !== action.payload);
    },
    openFileModal(state) {
      state.isFileModalOpen = true;
    },
    closeFileModal(state) {
      state.isFileModalOpen = false;
      state.isFileLoading = false;
    },
  },
});

export default importRoutesSlice;
